import React, { useState } from 'react';
import { usePrivacyConsent } from '../../../insfrastructure/hooks/usePrivacyConsent';
import { useResponsive } from '../../../insfrastructure/hooks/useResponsive';
import PrivacySettings from '../privacy-settings';

interface PrivacyConsentProps {
  onConsentChange?: (consent: boolean) => void;
}

export const PrivacyConsent: React.FC<PrivacyConsentProps> = ({ onConsentChange }) => {
  const { isLoading, showBanner, setConsent } = usePrivacyConsent();
  const { isMobile, isSmallScreen } = useResponsive();
  const [showSettings, setShowSettings] = useState(false);

  const handleAccept = async () => {
    await setConsent(true);
    onConsentChange?.(true);
  };

  const handleReject = async () => {
    await setConsent(false);
    onConsentChange?.(false);
  };

  if (!showBanner) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: '#f8f9fa',
      borderTop: '1px solid #dee2e6',
      padding: isSmallScreen ? '16px' : '20px',
      zIndex: 9999,
      boxShadow: '0 -2px 10px rgba(0,0,0,0.1)'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'flex',
        alignItems: isSmallScreen ? 'flex-start' : 'center',
        gap: isSmallScreen ? '16px' : '20px',
        flexWrap: 'wrap',
        flexDirection: isMobile ? 'column' : 'row'
      }}>
        <div style={{ 
          flex: 1, 
          minWidth: isMobile ? '100%' : '300px',
          marginBottom: isMobile ? '16px' : '0'
        }}>
          <h4 style={{ 
            margin: '0 0 8px 0', 
            color: '#105099',
            fontSize: isMobile ? '14px' : '16px',
            fontWeight: '600',
            lineHeight: '1.3'
          }}>
            🛡️ Privacidade e Monitoramento
          </h4>
          <p style={{ 
            margin: '0 0 12px 0', 
            color: '#666',
            fontSize: isMobile ? '13px' : '14px',
            lineHeight: '1.4'
          }}>
            Utilizamos ferramentas de monitoramento (Sentry) para melhorar a experiência e identificar problemas técnicos. 
            <strong> Nenhum dado pessoal é coletado</strong> - apenas informações técnicas anônimas sobre erros e performance.
          </p>
          <div style={{ 
            fontSize: isMobile ? '11px' : '12px', 
            color: '#888',
            lineHeight: '1.4'
          }}>
            <div style={{ marginBottom: '4px' }}>
              <strong>O que coletamos:</strong> Erros técnicos, métricas de performance, informações do navegador (anônimas)
            </div>
            <div style={{ marginBottom: '8px' }}>
              <strong>O que NÃO coletamos:</strong> Senhas, emails, CPFs, dados pessoais, conteúdo de formulários
            </div>
            <button 
              type="button"
              onClick={() => setShowSettings(true)}
              style={{ 
                color: '#105099', 
                textDecoration: 'underline',
                background: 'none',
                border: 'none',
                padding: '4px 0',
                cursor: 'pointer',
                fontSize: 'inherit',
                display: 'block',
                textAlign: 'left',
                width: '100%'
              }}
            >
              ⚙️ Configurar preferências de privacidade
            </button>
          </div>
        </div>
        
        <div style={{ 
          display: 'flex', 
          gap: isMobile ? '8px' : '12px', 
          flexWrap: 'wrap',
          alignItems: 'center',
          width: isMobile ? '100%' : 'auto',
          justifyContent: isMobile ? 'stretch' : 'flex-end'
        }}>
          <button
            onClick={handleAccept}
            disabled={isLoading}
            style={{
              backgroundColor: '#105099',
              color: 'white',
              border: 'none',
              padding: isMobile ? '14px 20px' : '12px 24px',
              borderRadius: '6px',
              cursor: isLoading ? 'not-allowed' : 'pointer',
              fontSize: isMobile ? '13px' : '14px',
              fontWeight: '500',
              opacity: isLoading ? 0.7 : 1,
              flex: isMobile ? '1' : 'none',
              minHeight: isMobile ? '44px' : 'auto',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            {isLoading ? '⏳ Processando...' : 'Aceitar'}
          </button>
          
          <button
            onClick={handleReject}
            disabled={isLoading}
            style={{
              backgroundColor: 'transparent',
              color: '#666',
              border: '1px solid #dee2e6',
              padding: isMobile ? '14px 20px' : '12px 24px',
              borderRadius: '6px',
              cursor: isLoading ? 'not-allowed' : 'pointer',
              fontSize: isMobile ? '13px' : '14px',
              fontWeight: '500',
              flex: isMobile ? '1' : 'none',
              minHeight: isMobile ? '44px' : 'auto',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            Recusar
          </button>
        </div>
      </div>
      
      {/* Modal de Configurações de Privacidade */}
      <PrivacySettings 
        isOpen={showSettings}
        onClose={() => setShowSettings(false)}
      />
    </div>
  );
};

export default PrivacyConsent;
